<template>
  <fragment>
        <tr>
            <td class="price-column-name table-cell service-name" colspan="100%">
                {{service.name}}
            </td>
        </tr>
        <tr v-for="detail in serviceDetails" class="price-column" v-if="mode !== 'no_tariff'">
            <td class="price-column-name">
                {{__(detail.perm_name)}}
            </td>
            <td class="table-cell" v-for="tariff in tariffs" v-if="read_only">
                <span v-if="tariff.type != 'free' && !isEmpty(tariff.tariffs_details[detail.id])">
                  {{formatValue(tariff.tariffs_details[detail.id] )}}
                </span>
                <span v-else-if="tariff.type != 'free' && isEmpty(tariff.tariffs_details[detail.id])">
                  <i class="fas fa-minus"></i>
                </span>
                <span v-else>
                  <i :class="[tariff.tariffs_details[detail.id] == null ? 'fas fa-minus' : 'fas fa-check' ]"></i>
                </span>
            </td>
            <td class="table-cell" v-else-if="allowSetServiceTariffDetail(tariff, detail)">
                <input
                  v-if="tariff.type == 'free'"
                  type="checkbox"
                  class="form-control"
                  :name="detail.id"
                  :class="detail.name"
                  :disabled="(tariff.readonly && (action =='create' || action =='copy' )) || (tariff.hasOwnProperty('no_price') && !tariff.no_price.includes(detail.id) && action !='create') || (tariff.price_list && (tariff.price_list.type == 'standard' ||tariff.price_list.type == 'special')) "
                  v-model="tariff.tariffs_details[detail.id]">
                <input
                  v-else
                  :disabled="disableRefillableField(tariff,detail)"
                  type="text"
                  step="0.01"
                  class="form-control exchange_field"
                  min="0.00"
                  :readonly="action == 'edit' && tariff.readonly && checkPriceForComplete(tariff,detail.id) "
                  :name="detail.id"
                  @change="changeValue($event, tariff, detail)"
                  :value="getInputFormatedValue(tariff.tariffs_details[detail.id])">
                <span class="text-danger" v-if="validatedForm(tariff, detail)">
                  {{__("wrong_value")}}
                </span>
            </td>
            <td v-else class="prices-disabled">
            </td>
        </tr>
      <tr v-for="detail in serviceDetails" class="price-column" v-if="mode == 'no_tariff'">
          <td class="price-column-name">
              {{__(detail.perm_name)}}
          </td>
          <td class="table-cell"> <input v-if="action !== 'show'"
              type="text"
              step="0.01"
              class="form-control exchange_rate_no_tariff"
              min="0.00"
              :name="detail.id"
              v-model="nonTariff[detail.id]"
              @change="changeNonTariffValue($event, detail.id)"
              :readonly="isReadonly && checkIsComplete(detail.id)"
          />
              <span v-else class="text-right">
                      {{formatValue(nonTariff[detail.id] )}}
              </span>
              <span class="text-danger" v-if="validatedFormNonTariff(detail.id)">
                  {{__("wrong_value")}}
                </span>
          </td>
          <td class="table-cell text-left">{{ tariffCurrencyDescription(detail) }}</td>

      </tr>
    </fragment>
</template>

<script>
import {mapGetters} from 'vuex';
import {Fragment} from 'vue-fragment';
import Utils from './../../../services/Utils.js';
import {Money} from './../../../services/Money.js';

export default {
  data : function () {
      return {
        details : {},
        money: new Money(),
        maxValue : 99999999,
          nonTariff:{},
          isReadonly: false,
          price_list_complete: true,
          noPriceNoTariff:[]
      }
  },
  components : {
    Fragment
  },
  props : [
    'service',
    'tariffs',
    'tariff_price_details',
    'validated_form',
    'read_only',
    'validated_message',
    'action',
      'mode',

  ],
  computed : {
    serviceDetails : function() {
        return this.$props.service.service_template_details
    },
    disableField : function () {
      return 0;
    },
    ...mapGetters({tariffs_details : 'getTariffDetails'}),

  },
  methods : {
      tariffCurrencyDescription(detail) {
          let str = $.i18n._(detail.fee_base + '_description')
          if(detail.free_documents !== null && detail.free_documents > 0){
              str+= ' ('+ $.i18n._('free_documents_first_part_price_list_description') +detail.free_documents +  $.i18n._("free_documents_second_part_price_list_description")+')'
          }
          return str;
      },
      checkIsComplete(id){
          if(this.price_list_complete == 0 && this.noPriceNoTariff.includes(id)){
              return false
          }
        return true;
      },
      checkPriceForComplete(tariff, id)
      {
          if(tariff.is_complete == 0 && tariff.no_price.includes(id)){
              return false;
          }
          return true;
      },
      changeNonTariffValue(e, id){
          let value = this.money.normalize(e.target.value);
          if (value != NaN && value >= 0 && value != '') {
              e.target.value = this.money.formatInt(e.target.value);
              this.nonTariff[id] = this.money.formatInt(e.target.value)
          }else {
              e.target.value = '';
              this.nonTariff[id] = ''
          }
          this.$emit('nonTariffChange', this.nonTariff)
          this.$forceUpdate()
      },
      validatedForm(tariff, detail) {
          var validPrice = true;
          if(['pre_paid', 'surcharge', 'subscription'].includes(tariff.type)){
              validPrice = tariff.tariffs_details[detail.id] < 0 || tariff.tariffs_details[detail.id] === ''
          }
          else{
              validPrice = tariff.tariffs_details[detail.id] <= 0 || tariff.tariffs_details[detail.id] === ''
          }
        let val =  tariff.type != 'free'
          && this.$props.validated_form
          && (
              (
                this.isEmpty(tariff.tariffs_details[detail.id])
                || validPrice
                || isNaN(tariff.tariffs_details[detail.id])
              )
              || parseFloat(tariff.tariffs_details[detail.id]) > this.maxValue
            );
          return val;
      },
      validatedFormNonTariff(detailID) {
         if(this.$props.validated_form){
             if(this.isEmpty(this.nonTariff[detailID])|| this.nonTariff[detailID] < 0
                 || isNaN(this.nonTariff[detailID])){
                 return true;
             }
             return false
         }
         return false;
      },
      changeValue(e, tariff, detail) {
          let value = this.money.normalize(e.target.value);
          if (value != NaN && value >= 0 && value != '') {
            tariff.tariffs_details[detail.id] = this.money.normalize(e.target.value);
            e.target.value = this.money.format(e.target.value);
          } else {
            e.target.value = '';
            tariff.tariffs_details[detail.id] = '';
          }
      },
      getInputFormatedValue(value) {
          let formated = ''
          if (value != NaN && value >= 0 && value !== '') {
            formated = this.money.format(value);
          }
          return formated;
      },
      allowSetServiceTariffDetail : function (tariff, detail) {
          let is_disabled = '' ;
          if(this.mode=='no_tariff')
          {
              return true
          }
          switch (tariff.type) {

            case 'free':
                return true;
              break;
            case 'pre_paid':
              is_disabled = this.$props.service.name == 'CONTsup BUSINESS' ? true : this.$props.service.name == 'CONTsup COMPLEX' ? true : this.$props.service.name == 'CONTsup PRO' ? true : false;
              if (!is_disabled) {
                this.setDisabledValue(tariff, detail.id);
              }
              break;
            case 'surcharge':
              is_disabled = this.$props.service.name == 'CONTsup BUSINESS' ? true : this.$props.service.name == 'CONTsup COMPLEX' ? true : this.$props.service.name == 'CONTsup PRO' ? true : false;
              if (!is_disabled) {
                this.setDisabledValue(tariff, detail.id);
              }
              break;
            case 'subscription':
              is_disabled = this.$props.service.name == 'CONTsup BUSINESS' ? false : this.$props.service.name == 'CONTsup COMPLEX' ? true : this.$props.service.name == 'CONTsup PRO' ? true : false;
              if (!is_disabled) {
                this.setDisabledValue(tariff, detail.id);
              }
              break;
            default:

          }
          return is_disabled;
      },
      disableRefillableField(tariff, detail) {
       let value = false;
        if(this.action == 'refill') {
            for(var i = 0; i < tariff.tariff_details.length; i++) {
                if (tariff.tariff_details[i].id == detail.id) {
                    value = true;
                    break;
                }
            }
        }
        return value;
      },
      setDisabledValue(tariff, detail) {
        delete tariff.tariffs_details[detail];

      },
      isEmpty(value) {
          return Utils.isEmpty(value);
      },
      formatValue(value) {
        return this.money.localize(value);
      }

  },
  mounted: function() {
        if(this.mode == 'no_tariff' && this.action == 'create'){
            const _this = this;
            this.service.service_template_details.forEach(function (item){
                _this.nonTariff[item.id] = ''
            })
        }
  }
}
</script>

<style lang="css" scoped>

</style>

